import React, { Component } from 'react';
import { Section } from './ui/Section';
import { Check, Printer, StickyNote, RefreshCw, BookOpen, Gift, Sparkles, ClipboardList, ArrowLeftRight, Clock, CheckSquare, MessageSquare, Star } from 'lucide-react';
export function Features() {
  const kitItems = [{
    text: 'Rutinas visuales imprimibles (2–13)',
    icon: ClipboardList,
    color: 'text-[#4AAAA5]'
  }, {
    text: "Tarjetas 'Primero–Después' y 'Cuando–Entonces'",
    icon: ArrowLeftRight,
    color: 'text-[#E8845F]'
  }, {
    text: "Tarjetas de tiempo (ej: 'Faltan 5 minutos')",
    icon: Clock,
    color: 'text-[#F5C842]'
  }, {
    text: 'Checklist de salida (mochila/agua/llaves…)',
    icon: CheckSquare,
    color: 'text-[#4AAAA5]'
  }, {
    text: '12 guiones de 10 segundos (listos para usar)',
    icon: MessageSquare,
    color: 'text-[#E8845F]'
  }, {
    text: 'Tablero de puntos simple (2 estilos) para motivar sin sobornos',
    icon: Star,
    color: 'text-[#F5C842]'
  }];
  const manualItems = ['Cómo imprimir y recortar', 'Cómo plastificar (opcional)', 'Cómo usar velcro/imanes/argollas', 'Dónde pegarlo para que funcione', 'Cómo presentarlo a tu hijo', 'Plan de 14 días + troubleshooting'];
  return <>
      <Section background="white" data-id="element-149">
        <div className="text-center max-w-3xl mx-auto mb-10" data-id="element-150">
          <span className="inline-flex items-center px-4 py-2 rounded-full bg-[#E6F4F4] text-[#4AAAA5] font-bold text-sm mb-4" data-id="element-151">
            <Gift className="w-4 h-4 mr-2" data-id="element-152" />
            Todo incluido
          </span>
          <h2 className="text-3xl md:text-4xl font-extrabold text-gray-800 mb-4" data-id="element-153">
            Qué incluye el Kit (PDF imprimible)
          </h2>
        </div>

        {/* Kit Contents Image */}
        <div className="max-w-4xl mx-auto mb-12" data-id="element-154">
          <div className="rounded-3xl overflow-hidden shadow-xl border-4 border-white bg-[#FDF8F3] relative" data-id="element-155">
            <div className="absolute top-4 left-4 z-10" data-id="element-156">
              <span className="bg-[#4AAAA5] text-white text-sm font-bold px-4 py-2 rounded-full shadow-md inline-flex items-center gap-1.5" data-id="element-157">
                <Sparkles className="w-4 h-4" data-id="element-158" />
                Vista previa del kit
              </span>
            </div>
            <img src="https://cdn.magicpatterns.com/uploads/93Jbo5EcyFVYyYMtSzfnKo/Transforma_gritos_y_berrinches_en_rutinas_de_paz_con_este_metodo_visual_en_menos_de_7_dias_4_20301690-a112-4497-86b1-18393e0d7021.png" alt="Contenido del Kit: Rutinas diarias, tarjetas de actividades, calendarios y más" className="w-full h-auto object-contain" data-id="element-159" />
          </div>
        </div>

        <div className="grid lg:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-160">
          {/* Kit Principal */}
          <div className="bg-gradient-to-br from-[#E6F4F4] to-[#D4EFED] p-8 rounded-3xl border-2 border-[#4AAAA5]/20 relative overflow-hidden" data-id="element-161">
            <div className="absolute -top-10 -right-10 w-32 h-32 bg-[#4AAAA5] opacity-10 rounded-full blur-2xl" data-id="element-162"></div>
            <div className="flex items-center gap-3 mb-6" data-id="element-163">
              <div className="bg-[#4AAAA5] p-3 rounded-2xl shadow-lg" data-id="element-164">
                <Check className="w-6 h-6 text-white" data-id="element-165" />
              </div>
              <div data-id="element-166">
                <span className="text-sm font-bold text-[#4AAAA5] uppercase tracking-wide" data-id="element-167">
                  Producto Principal
                </span>
                <h3 className="text-xl font-extrabold text-gray-800" data-id="element-168">
                  Kit Imprimible (PDF)
                </h3>
              </div>
            </div>
            <ul className="space-y-4" data-id="element-169">
              {kitItems.map((item, idx) => {
              const IconComponent = item.icon;
              return <li key={idx} className="flex items-start" data-id="element-170">
                    <div className={`w-6 h-6 mr-3 flex-shrink-0 ${item.color}`} data-id="element-171">
                      <IconComponent className="w-5 h-5" data-id="element-172" />
                    </div>
                    <span className="text-gray-700" data-id="element-173">{item.text}</span>
                  </li>;
            })}
            </ul>
          </div>

          {/* Manual de Regalo */}
          <div className="bg-gradient-to-br from-[#FFF5E6] to-[#FFEDD5] p-8 pt-10 rounded-3xl border-2 border-[#E8845F]/20 relative" data-id="element-174">
            <div className="absolute top-3 right-3 bg-gradient-to-r from-[#E8845F] to-[#F5A574] text-white text-xs font-bold px-4 py-2 rounded-full transform rotate-6 shadow-lg z-10 inline-flex items-center gap-1" data-id="element-175">
              <Gift className="w-3 h-3" data-id="element-176" />
              BONUS
            </div>
            <div className="absolute -bottom-10 -left-10 w-32 h-32 bg-[#E8845F] opacity-10 rounded-full blur-2xl" data-id="element-177"></div>
            <div className="flex items-center gap-3 mb-6 mt-2" data-id="element-178">
              <div className="bg-[#E8845F] p-3 rounded-2xl shadow-lg" data-id="element-179">
                <BookOpen className="w-6 h-6 text-white" data-id="element-180" />
              </div>
              <div data-id="element-181">
                <span className="text-sm font-bold text-[#E8845F] uppercase tracking-wide" data-id="element-182">
                  Bonus Incluido
                </span>
                <h3 className="text-xl font-extrabold text-gray-800" data-id="element-183">
                  Manual de Implementación (eBook)
                </h3>
              </div>
            </div>
            <p className="text-gray-600 mb-4" data-id="element-184">
              Un paso a paso corto y práctico para que lo armes sin dudas:
            </p>
            <ul className="space-y-3" data-id="element-185">
              {manualItems.map((item, idx) => <li key={idx} className="flex items-start" data-id="element-186">
                  <div className="bg-white rounded-full p-1 mr-3 mt-0.5 shadow-sm" data-id="element-187">
                    <Sparkles className="w-4 h-4 text-[#E8845F]" data-id="element-188" />
                  </div>
                  <span className="text-gray-700 text-sm" data-id="element-189">{item}</span>
                </li>)}
            </ul>
          </div>
        </div>

        <div className="mt-10 text-center" data-id="element-190">
          <p className="text-lg text-gray-700 bg-[#FFFDF5] inline-block px-6 py-3 rounded-2xl border-2 border-[#F5C842]/30" data-id="element-191">
            <span className="font-bold" data-id="element-192">Clave:</span> compras el{' '}
            <span className="text-[#4AAAA5] font-bold" data-id="element-193">kit</span> (lo práctico)
            y te llevas{' '}
            <span className="text-[#E8845F] font-bold" data-id="element-194">la guía</span> (para que
            funcione de verdad).
          </p>
        </div>
      </Section>

      <Section background="cream" data-id="element-195">
        <div className="max-w-4xl mx-auto" data-id="element-196">
          <div className="text-center mb-12" data-id="element-197">
            <h2 className="text-3xl font-extrabold text-gray-800 mb-4" data-id="element-198">
              Cómo se usa
            </h2>
          </div>

          <div className="grid grid-cols-1 sm:grid-cols-3 gap-6" data-id="element-199">
            {[{
            icon: <Printer className="w-8 h-8" data-id="element-200" />,
            text: 'Imprimes',
            desc: 'Descargas el PDF y lo imprimes en casa.',
            num: '1'
          }, {
            icon: <StickyNote className="w-8 h-8" data-id="element-201" />,
            text: 'Pegas',
            desc: 'Lo colocas donde tu hijo pueda verlo.',
            num: '2'
          }, {
            icon: <RefreshCw className="w-8 h-8" data-id="element-202" />,
            text: 'Repites',
            desc: 'Y cuando aparezca el berrinche, vuelves al sistema.',
            num: '3'
          }].map((step, idx) => <div key={idx} className="flex flex-col items-center text-center p-6 bg-white rounded-3xl shadow-lg relative" data-id="element-203">
                <div className="absolute -top-3 -left-3 bg-[#F5C842] text-gray-900 font-extrabold w-8 h-8 rounded-full flex items-center justify-center shadow-md" data-id="element-204">
                  {step.num}
                </div>
                <div className="bg-gradient-to-br from-[#4AAAA5] to-[#5CBFBA] text-white p-4 rounded-2xl mb-4 shadow-lg" data-id="element-205">
                  {step.icon}
                </div>
                <span className="font-extrabold text-xl text-gray-800 mb-2" data-id="element-206">
                  {step.text}
                </span>
                <p className="text-gray-600 text-sm" data-id="element-207">{step.desc}</p>
              </div>)}
          </div>
        </div>
      </Section>
    </>;
}